import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from 'reactstrap';
import _ from 'lodash';

const ListaSelector = props => {

  const {
    globals,
    list,
    cols,
    selectLista,
  } = props;

  useEffect(() => {
    if(cols > 4){
      console.error('Number of columns could not be greather than 4.');
    }
  }, []);

  const renderListaSelector = () => {
    const colWidth = cols == 3 ? 2 : 3; 
    const rowNum = Math.ceil(list.length / cols);
    let listaRows = [];

    for(let rowIdx = 0; rowIdx < rowNum; rowIdx++){
      let listaCols = [];
      for(let colIdx = 0; colIdx < cols; colIdx++){
        const listaElement = list[rowIdx * cols + colIdx];
        if(listaElement && globals.hasRoleSpec([listaElement.role])){
          listaCols.push(
            <div className={"col-md-" + colWidth} key={'col-' + (rowIdx * cols + colIdx)}>
              <Button type="button" color="primary" style={{width: '100%', whiteSpace:"break-spaces" }} onClick={() => selectLista(listaElement.name)}>{listaElement.label}</Button>
            </div>
          );
          if(cols == 2 && colIdx == 0)  listaCols.push(<div className="col-md-6" key={'sep-' + (rowIdx * cols + colIdx)}></div>);
          if(cols == 3 && (colIdx == 0 || colIdx == 1))  listaCols.push(<div className="col-md-3" key={'sep-' + (rowIdx * cols + colIdx)}></div>);
        }
      }
      listaRows.push(<div className="row" style={{margin: '20px'}} key={'row-' + rowIdx}> {listaCols} </div>);
    }

    return(
      <React.Fragment>
        {listaRows}
      </React.Fragment>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderListaSelector()}
      </div>
    </div>
  );
}

export default ListaSelector;
